module.exports = __webpack_public_path__ + "files/fa18aef60303966cc18172b61573480f.png";